import merge from 'lodash/merge';

const customizeTheme = showSecureHeader => theme => {
    return merge(theme, {
        header: {
            mobileMenu: {
                enabled: !showSecureHeader,
            },
        },
        footer: {
            showPricingLink: !showSecureHeader,
            showSEO: !showSecureHeader,
            showSupport: true,
        },
    });
};

export default customizeTheme;
